import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import {
    initTrackingMiddleware,
    trackingMiddleware
} from './middleware/trackingMiddleware';

import rootReducer from './reducers';

import { routerMiddleware } from 'react-router-redux';

const configureStore = (initialState, history) => {
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers =
        typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
            : compose;
    /* eslint-enable */

    initTrackingMiddleware(initialState.widget);
    const createdRouterMiddleware = routerMiddleware(history);

    const enhancer = composeEnhancers(
        applyMiddleware(createdRouterMiddleware, thunk, trackingMiddleware)
    );

    const store = createStore(rootReducer, initialState, enhancer);

    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            // Enable Webpack hot module replacement for reducers
            module.hot.accept('./reducers', () => {
                /* eslint-disable */
        const nextRootReducer = require('./reducers').default
        /* eslint-enable */
                store.replaceReducer(nextRootReducer);
            });
        }
    }

    return store;
};

export default configureStore;
